//import { MbscModule } from '@mobiscroll/angular_old';
//import { MbscTimespanModule, MbscColorModule } from '@mobiscroll/angular_old';
import { MbscDatepickerModule } from '@mobiscroll/angular';
import {
  ContractExtra,
  DocumentDirectory,
  DocumentFile,
  EquipRepairTicket,
  JobPlanAlarm,
  JobRestorationMedia,
  SpringRestoration,
} from '@app/models';
import { NetworkRequiredPageModule } from './public/network-required/network-required.module';
import { NgModule } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';

import { PerfectScrollbarModule } from '@harvest-dev/ng-perfect-scrollbar';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { IonicStorageModule } from '@ionic/storage-angular';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { DateFnsModule } from 'ngx-date-fns';

import {
  FontAwesomeModule,
  FaIconLibrary,
} from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { StateModule } from './state/state.module';
import { EquipmentClass } from './models/equipment-class.model';
import { MappedEntityService } from '@services/api/mapped-entity.service';
import { ApiInterceptorService } from '@services/api/api-interceptor.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  EquipmentType,
  EquipmentModel,
  EquipmentMachine,
  EquipmentOption,
  EquipmentOptionType,
  EquipmentUntrackedClass,
  EquipmentUntrackedMachine,
  User,
  UserRole,
  ImportStatus,
  Vendor,
  MaterialCategory,
  MaterialVendor,
  SubcontractorCategory,
  SubcontractorVendor,
  RestorationCategory,
  RestorationVendor,
  RestorationType,
  JobEquipment,
  Job,
  TruckingRequirement,
  TruckingMove,
  TruckingEquipLocation,
  JobPlan,
  JobPlanManager,
  JobPlanCrewRequirement,
  Crew,
  Bid,
  BidItem,
  BidWorksheet,
  JobPlanCrewAssignment,
  JobLocate,
  JobPlanTentative,
  JobNote,
  JobNoBoxReason,
  JobDocument,
  JobMedia,
  JobIncident,
  JobIncidentMedia,
  JobMaterial,
  JobRestoration,
  JobSubcontractor,
  JobSiteEquipment,
  JobDateTimecard,
  JobFieldLogTotalTime,
  JobExtra,
  JobDateNote,
  UserTimecard,
  JobDateCrew,
  JobFieldLog,
} from './models';
import { TruckingMoveService } from '@services/api/trucking-move.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UtilsModule } from '@components/utils/utils.module';
import { LaunchNavigator } from '@awesome-cordova-plugins/launch-navigator/ngx';
import { SharedComponentsModule } from '@shared/components/shared-components.module';
import { JobAlert } from './models/job-alert.model';
import { UserTimecardsService } from '@services/api/user-timecards.service';
import { JobDateCrewService } from '@services/api/job-date-crew.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    //MbscModule,
    //MbscTimespanModule,
    //MbscColorModule,
    MbscDatepickerModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    IonicModule.forRoot({ mode: 'md' }),
    IonicStorageModule.forRoot(),
    DateFnsModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    FontAwesomeModule,
    StateModule,
    PerfectScrollbarModule,
    UtilsModule,
    NetworkRequiredPageModule,
    SharedComponentsModule,
    HammerModule,
  ],
  providers: [
    ScreenOrientation,
    LaunchNavigator,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptorService,
      multi: true,
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ContractExtra, useClass: MappedEntityService },
    { provide: Crew, useClass: MappedEntityService },
    { provide: Bid, useClass: MappedEntityService },
    { provide: BidItem, useClass: MappedEntityService },
    { provide: BidWorksheet, useClass: MappedEntityService },
    { provide: DocumentDirectory, useClass: MappedEntityService },
    { provide: DocumentFile, useClass: MappedEntityService },
    { provide: EquipmentClass, useClass: MappedEntityService },
    { provide: EquipmentType, useClass: MappedEntityService },
    { provide: EquipmentModel, useClass: MappedEntityService },
    { provide: EquipmentMachine, useClass: MappedEntityService },
    { provide: EquipmentOption, useClass: MappedEntityService },
    { provide: EquipmentOptionType, useClass: MappedEntityService },
    { provide: EquipmentUntrackedClass, useClass: MappedEntityService },
    { provide: EquipmentUntrackedMachine, useClass: MappedEntityService },
    { provide: Job, useClass: MappedEntityService },
    { provide: JobEquipment, useClass: MappedEntityService },
    { provide: JobPlan, useClass: MappedEntityService },
    { provide: JobPlanAlarm, useClass: MappedEntityService },
    { provide: JobPlanCrewRequirement, useClass: MappedEntityService },
    { provide: JobPlanCrewAssignment, useClass: MappedEntityService },
    { provide: JobPlanManager, useClass: MappedEntityService },
    { provide: MaterialCategory, useClass: MappedEntityService },
    { provide: MaterialVendor, useClass: MappedEntityService },
    { provide: RestorationCategory, useClass: MappedEntityService },
    { provide: RestorationType, useClass: MappedEntityService },
    { provide: RestorationVendor, useClass: MappedEntityService },
    { provide: SpringRestoration, useClass: MappedEntityService },
    { provide: SubcontractorCategory, useClass: MappedEntityService },
    { provide: SubcontractorVendor, useClass: MappedEntityService },
    { provide: User, useClass: MappedEntityService },
    { provide: UserRole, useClass: MappedEntityService },
    { provide: ImportStatus, useClass: MappedEntityService },
    { provide: Vendor, useClass: MappedEntityService },
    { provide: TruckingRequirement, useClass: MappedEntityService },
    { provide: TruckingMove, useClass: TruckingMoveService },
    { provide: TruckingEquipLocation, useClass: MappedEntityService },
    { provide: JobLocate, useClass: MappedEntityService },
    { provide: JobPlanTentative, useClass: MappedEntityService },
    { provide: JobNote, useClass: MappedEntityService },
    { provide: JobNoBoxReason, useClass: MappedEntityService },
    { provide: JobAlert, useClass: MappedEntityService },
    { provide: JobDateNote, useClass: MappedEntityService },
    { provide: JobDocument, useClass: MappedEntityService },
    { provide: JobMedia, useClass: MappedEntityService },
    { provide: JobIncident, useClass: MappedEntityService },
    { provide: JobIncidentMedia, useClass: MappedEntityService },
    { provide: JobMaterial, useClass: MappedEntityService },
    { provide: JobSubcontractor, useClass: MappedEntityService },
    { provide: JobRestoration, useClass: MappedEntityService },
    { provide: JobRestorationMedia, useClass: MappedEntityService },
    { provide: JobSiteEquipment, useClass: MappedEntityService },
    { provide: JobDateTimecard, useClass: MappedEntityService },
    { provide: JobFieldLogTotalTime, useClass: MappedEntityService },
    { provide: JobExtra, useClass: MappedEntityService },
    { provide: EquipRepairTicket, useClass: MappedEntityService },
    { provide: UserTimecard, useClass: UserTimecardsService },
    { provide: JobDateCrew, useClass: JobDateCrewService },
    { provide: JobFieldLog, useClass: MappedEntityService },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, far);
  }
}
